import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import EventBusyIcon from "@mui/icons-material/EventBusy";

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { NavContext, NavRoutes } from "../../../contexts";
import { ComuneContext } from '../ComuneContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const CompetenzeList = ({
    disabled,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(ComuneContext);

    const {
        comune,
        competenze,
    } = state;

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    const importClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Import", data);
    }

    return (
        <>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            sx={{
                                color: "white",
                                backgroundColor: "secondary.main",
                            }}
                            title={
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h6">Competenze</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            color="info"
                                            disabled={disabled}
                                            onClick={importClickHandler}
                                            style={{ marginLeft: 8 }}
                                        >
                                            Importa
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                        />
                        <Divider />
                        <CardContent sx={{ padding: "0px !important" }}>
                            <Table>
                                <TableHead sx={{
                                    backgroundColor: "aliceblue",
                                }}>
                                    <TableRow>
                                        <TableCell style={{ width: "50%" }}>Nome competenza</TableCell>
                                        <TableCell style={{ width: "50%" }}>Nome ufficio</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        competenze && competenze.result.length > 0 ? competenze?.result.map((competenza, index) =>
                                            <TableRow key={index}>
                                                <TableCell style={{ width: "50%" }}>
                                                    <div sx={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <div>
                                                            <Link
                                                                color="textPrimary"
                                                                onClick={() => window.open(getRouteTo(NavRoutes.ComuneCompetenza, [comune.id, competenza.competenzaId]), "_blank").focus()}
                                                                sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                                {competenza.competenza.tipoUfficio?.nome}
                                                                {[
                                                                    competenza.comune?.provincia?.regione
                                                                        ?.fineValidita,
                                                                    competenza.comune?.provincia?.fineValidita,
                                                                    competenza.comune?.dataCessazione,
                                                                    competenza.ufficio?.fineValidita,
                                                                    competenza.ufficio?.tipoUfficio?.fineValidita,
                                                                    competenza.competenza?.fineValidita,
                                                                    competenza.fineValidita,
                                                                ].some((x) => x && x <= new Date()) && (
                                                                        <EventBusyIcon
                                                                            color={
                                                                                competenza.fineValidita &&
                                                                                    competenza.fineValidita <= new Date()
                                                                                    ? "error"
                                                                                    : "warning"
                                                                            }
                                                                        />
                                                                    )}
                                                            </Link>
                                                        </div>
                                                    </div>

                                                </TableCell>
                                                <TableCell sx={{ color: !competenza?.ufficioId && 'red' }}>
                                                    {competenza?.ufficio?.nome ?? competenza?.messaggio}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="delete"
                                                        disabled={disabled}
                                                        onClick={() => deleteClickHandler(competenza)}>
                                                        <Tooltip title="Rimuovi ufficio">
                                                            <DeleteIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>)
                                            :
                                            <TableRow>
                                                <TableCell align="center" colSpan="100%"
                                                    sx={{ padding: 8, color: "primary.main", fontWeight: "bold" }}>
                                                    NON SONO PRESENTI COMPETENZE
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid >
        </>
    );
}